import { Combobox } from "cerulean";
import filters from "byzantine/src/filters";
import { useLayoutEffect, useState } from "react";

type WireReasonSelectorProps = {
  reasons: API.InternationalWireReason[];
  onChange: (value: string) => void;
  value: string;
  label: string;
  error: string;
};

const WireReasonSelector = ({
  reasons,
  onChange,
  value,
  label,
  error,
}: WireReasonSelectorProps) => {
  const selectedReason = reasons.find((c) => c.code === value);
  const [inputValue, setInputValue] = useState<string>(
    selectedReason ? selectedReason.code : ""
  );

  const displayValue = ({
    code,
    description,
  }: {
    code: string;
    description: string;
  }) => `${code}: ${filters.humanize(description)}`;

  // whenever `value` changes externally, update inputValue (what is displayed in the input) to match
  useLayoutEffect(() => {
    setInputValue(selectedReason ? displayValue(selectedReason) : "");
  }, [value, selectedReason]);

  const handleChange = (c: string) => {
    onChange(c);
    const pickedReason = reasons.find((r) => r.code === c);
    setInputValue(pickedReason ? displayValue(pickedReason) : "");
  };

  return (
    <Combobox
      field="wireReason"
      label={label}
      value={value}
      onChange={handleChange}
      errorText={error}
      inputValue={inputValue}
      onInputChange={(updatedValue: string) => {
        setInputValue(updatedValue);
      }}
    >
      {reasons.map(({ code, description }) => (
        <Combobox.Item
          key={code}
          value={code}
          searchValue={displayValue({ code, description })}
        >
          {displayValue({ code, description })}
        </Combobox.Item>
      ))}
    </Combobox>
  );
};

export default WireReasonSelector;